import { render, staticRenderFns } from "./SubEventScore.vue?vue&type=template&id=6de9c7a8&scoped=true"
import script from "./SubEventScore.vue?vue&type=script&lang=js"
export * from "./SubEventScore.vue?vue&type=script&lang=js"
import style0 from "./SubEventScore.vue?vue&type=style&index=0&id=6de9c7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9c7a8",
  null
  
)

export default component.exports